import { PropsWithChildren, useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';

import { ConditionView } from '@/shared/ui';

import AuthContext from '@/contexts/Auth/AuthContext';
import { SessionExpiredContext } from '@/contexts/SessionExpired';
import {
  clearSessionExpiredOnReload,
  isSessionExpiredOnReload,
  readSessionExpiredAllowPath,
} from '@/contexts/SessionExpired/utils';

import { ROUTES } from '../router/config';

export const PrivateRouteWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  const { isLoggedIn } = useContext(AuthContext);
  const { allowPath } = useContext(SessionExpiredContext);
  const { pathname, search, state } = useLocation();
  const currentPath = pathname + search;
  const allowPathFromStorage = readSessionExpiredAllowPath();

  if (!isLoggedIn && (allowPath === currentPath || allowPathFromStorage === currentPath)) {
    return children || <Outlet />;
  }

  if (!isLoggedIn && isSessionExpiredOnReload()) {
    clearSessionExpiredOnReload();
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return (
    <ConditionView if={!isLoggedIn} else={children || <Outlet />}>
      <Navigate to={ROUTES.LOGIN} state={{ ...state, nextPage: pathname + search }} replace />
    </ConditionView>
  );
};
